import { useMemo } from 'react'
import PropTypes from 'prop-types'
import './RegisterLicense'
import { ClientSideRowModelModule } from 'ag-grid-community'
import { assignFormatter } from './utils/valueFormatters'
import { assignRenderer } from './utils/cellRenderers'
import '../../styles/grid.scss'
import {
  DateCellEditor,
  NumericCellEditor,
  DropdownCellEditor,
  TextCellEditor,
} from './CellEditors'
import { CustomTooltip } from './Tooltip'
import { AgGridReact } from 'ag-grid-react'

// setting common defaults applicable for all apps
const defaultColumnDefinition = {
  menuTabs: ['filterMenuTab'],
  sortable: true,
  filter: true,
  resizable: true,
  editable: false,
  width: 100,
  suppressPaste: true,
}

const defaultGridOptions = {
  headerHeight: 48,
  groupHeaderHeight: 48,
  rowHeight: 24,
  suppressContextMenu: true,
  enableRangeSelection: true,
  suppressRowClickSelection: true,
  stopEditingWhenCellsLoseFocus: true,
  overlayNoRowsTemplate: '<span>Sorry, no data is found</span>',
  enableFillHandle: true,
  components: {
    dateCellEditor: DateCellEditor,
    numericCellEditor: NumericCellEditor,
    dropdownCellEditor: DropdownCellEditor,
    textCellEditor: TextCellEditor,
    customTooltip: CustomTooltip,
  },
}
const DataGrid = props => {
  const { width, height, editable, rowData, modules } = props
  let { gridOptions, columnDefs } = props
  const classes = editable
    ? 'ag-theme-material ag-grid-react'
    : 'ag-theme-material ag-grid-react non-editable'

  const defaultColDef = {
    ...defaultColumnDefinition,
    ...(gridOptions?.defaultColDef ?? {}),
  }

  const definedModules = useMemo(
    () => [ClientSideRowModelModule, ...(modules ?? [])],
    [modules],
  )

  if (gridOptions) {
    Object.assign(gridOptions, {
      ...defaultGridOptions,
      ...gridOptions,
      defaultColDef,
    })
  } else {
    gridOptions = { ...defaultGridOptions, defaultColDef }
  }

  //Pinning first column by default
  columnDefs = columnDefs.map(col => {
    if (col.order !== undefined && col.order === 0 && !col.pinned) {
      col.pinned = 'left'
    }
    if (col.valueFormatterType) {
      col.valueFormatter = assignFormatter(col.valueFormatterType)
      delete col.valueFormatterType
    }
    if (!col.cellRenderer && col.cellRendererType) {
      col.cellRenderer = assignRenderer(col.cellRendererType)
      delete col.cellRendererType
    }
    if (col.editable && !col.cellClass) {
      col.cellClass = 'ag-cell-edit-user'
    }
    return col
  })

  return (
    <div
      className={classes}
      style={{
        height: height,
        width: width,
      }}
    >
      <AgGridReact
        gridOptions={gridOptions}
        columnDefs={columnDefs}
        rowData={rowData}
        modules={definedModules}
      />
    </div>
  )
}

DataGrid.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  gridOptions: PropTypes.object,
  columnDefs: PropTypes.array.isRequired,
}

export default DataGrid
